// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { EmployeeAreaRoutes } from '@backoffice-frontend/employee-api'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { EmployeeAreaId } from './EmployeeAreaId'

import { EmployeeAreaNavigation } from './EmployeeAreaNavigation'

const LazyEmployeeComponent = lazy(() => import('./EmployeeArea'))

const EmployeeComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyEmployeeComponent />
  </SuspenseLoadingWrapper>
)

export const EmployeeArea = {
  id: EmployeeAreaId,
  requiredRight: BoumRight.AREA_EMPLOYEE,
  NavigationComponent: EmployeeAreaNavigation,
  route: {
    path: EmployeeAreaRoutes.route,
    component: EmployeeComponent,
  },
}
